import { ProductType } from "../models/product-type";
import { httpGet } from "./http-client";

const apiUrl = '/api/producttypes';

export const getProductTypes = () => httpGet<ProductType[]>(apiUrl);
